import { useState } from "react";
import { Key, ArrowLeft } from "iconsax-reactjs";
import { useNavigate } from "react-router-dom";
import apiService from "../../services/api";

export default function ForgotPassword() {
  const [email, setEmail]         = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError]         = useState("");
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setError("");
    if (!email.trim()) return;

    setIsLoading(true);
    try {
      const res = await apiService.forgotPassword(email.trim());
      if (res.success) setSubmitted(true);
      else setError(res.message || "Something went wrong.");
    } catch (err) {
      setError(err.response?.data?.message || "Failed to send reset email.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <img src="/assets/clockout-lockup-hero-2400.png" alt="Clock-out" className="auth-logo" />

      <div className="auth-card">
        {/* Icon */}
        <div className="flex justify-center mb-5">
          <div className="w-14 h-14 bg-[#FFC81E] rounded-[16px] flex items-center justify-center">
            <Key className="w-7 h-7 text-[#1C1A14]" />
          </div>
        </div>

        {submitted ? (
          /* ── Success State ── */
          <div className="text-center">
            <h1 className="auth-title">Check your email</h1>
            <p className="auth-subtitle mb-4">
              We sent a password reset link to <strong className="text-[#1C1A14]">{email}</strong>
            </p>
            <p className="text-[#857A63] text-sm">
              Didn't receive it? Check your spam folder or{" "}
              <button onClick={() => setSubmitted(false)} className="auth-link">
                try again
              </button>
            </p>
          </div>
        ) : (
          /* ── Form ── */
          <>
            <div className="text-center mb-7">
              <h1 className="auth-title">Forgot password?</h1>
              <p className="auth-subtitle">No worries, we'll send you reset instructions.</p>
            </div>

            <div className="space-y-5">
              {error && (
                <div className="px-4 py-3 bg-red-50 border border-red-200 rounded-[12px] text-sm text-red-700" role="alert">
                  {error}
                </div>
              )}

              <div>
                <label htmlFor="email" className="auth-label">Email</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                  placeholder="you@company.com"
                  autoComplete="email"
                  className="auth-input"
                />
              </div>

              <button
                onClick={handleSubmit}
                disabled={isLoading || !email.trim()}
                className="auth-btn-primary"
              >
                {isLoading ? (
                  <>
                    <div className="w-4 h-4 border-2 border-[#1C1A14] border-t-transparent rounded-full animate-spin"></div>
                    Sending…
                  </>
                ) : (
                  "Reset password"
                )}
              </button>
            </div>
          </>
        )}

        <hr className="auth-divider" />
        <button
          onClick={() => navigate("/login")}
          className="w-full text-sm text-[#4A4234] hover:text-[#1C1A14] font-semibold transition-colors flex items-center justify-center group"
        >
          <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform duration-200" />
          Back to sign in
        </button>
      </div>

      <p className="auth-footer">© {new Date().getFullYear()} Talk Nerdy To Me Consultancy Ltd. All rights reserved.</p>
    </div>
  );
}